import httpClient from "@/plugins/axios";

export const updateTenantColor = async (color) => {
    const response = await httpClient.put(`/admin/v1/tenant/color/`, { color });
    return response;
}
